export default function CreditCardSVG() {
  return (
    <>
      {/* prettier-ignore */}
      <svg aria-hidden="true" focusable="false" width="64" height="41" viewBox="0 0 64 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="1.95312" width="61.9184" height="39.0476" rx="5.20635" fill="var(--theme-primary)" fillOpacity="0.2"/>
        <rect x="2.45215" y="0.5" width="60.9184" height="38.0476" rx="4.70635" fill="white" stroke="var(--theme-primary)"/>
        <rect x="1.95215" y="6.70117" width="61.5" height="6.69388" fill="var(--theme-primary)"/>
        <rect x="20.8252" y="16.9199" width="23.4286" height="5.20635" rx="1.30159" fill="var(--theme-primary)" fillOpacity="0.2"/>
        <rect x="46.2061" y="16.9199" width="13.0159" height="5.20635" rx="2.60317" fill="var(--theme-primary)" fillOpacity="0.2"/>
        <circle cx="50.1108" cy="19.5238" r="0.650794" fill="white"/>
        <circle cx="52.7143" cy="19.5238" r="0.650794" fill="white"/>
        <circle cx="55.3173" cy="19.5238" r="0.650794" fill="white"/>
        <ellipse cx="9.93284" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="12.7571" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="15.5681" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="18.3952" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="22.6233" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="25.4475" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="28.2571" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="31.0862" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="35.2927" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="38.1174" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="40.928" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="43.7556" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="47.9851" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="50.8093" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="53.6203" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
        <ellipse cx="56.4475" cy="33.1915" rx="0.822002" ry="0.826239" fill="var(--theme-primary)"/>
      </svg>
    </>
  );
}
